import { CONTROLLER, METHOD } from "common/config/endpoint.config";
import { ApiConfig } from "common/models";
import { ApiResult } from "common/models/api-service/api-result.model";
import { UserSession } from "common/models/user-details.model";
import { GraphClient } from "common/services/graph-client.service";
import { HttpClient } from "common/services/http-client.service";
import { buildEngApiUrl } from "common/utils/api.util";

export class UserService extends HttpClient {
  public static async getUserProfile(): Promise<ApiResult<any>> {
    return GraphClient.getCurrentUserProfile();
  }

  public static async getUserImage(): Promise<ApiResult<Blob>> {
    return GraphClient.getCurrentUserAvatar();
  }

  public static async getAppUserProfile(): Promise<
    ApiResult<UserSession> | undefined
  > {
    return this.invokeApi(
      new ApiConfig(
        buildEngApiUrl(`${CONTROLLER.USERS}/${METHOD.SESSION}`),
        "POST"
      )
    );
  }

  // public static async getUserRole(): Promise<
  //   ApiResult<UserSession> | undefined
  // > {
  //   return this.invokeApi(
  //     new ApiConfig(`${CONTROLLER.USERS}/${METHOD.SESSION}`, "POST")
  //   );
  // }

  public static async logoutUser(): Promise<ApiResult<undefined> | undefined> {
    return this.invokeApi(
      new ApiConfig(
        buildEngApiUrl(`${CONTROLLER.USERS}/${METHOD.LOGOUT}`),
        "POST"
      )
    );
  }
}
